import { GLOBAL_SECONDS, GLOBAL_MINUTES, GLOBAL_HOURS } from "./actionType";

const initialState = {
  seconds: 0,
  minutes: 0,
  hours: 0,
};

const helperGlobalTimerReducer = (state = initialState, action) => {
  switch (action.type) {
    case GLOBAL_SECONDS:
      return {
        ...state,
        seconds: action.payload,
      };
    case GLOBAL_MINUTES:
      return {
        ...state,
        minutes: action.payload,
      };
    case GLOBAL_HOURS:
      return {
        ...state,
        hours: action.payload,
      };
    default:
      return state;
  }
};

export default helperGlobalTimerReducer;
